export default __webpack_public_path__ + "static/media/S-034.0d636d3a.png";